module.exports = __webpack_public_path__ + "bb5.no1.aaade9d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb5.no1.jpg
// module id = 6j/5
// module chunks = 0